import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-declined-members',
  templateUrl: './declined-members.component.html',
  styleUrls: ['./declined-members.component.css']
})
export class DeclinedMembersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/declined-members/declined-members.component.ts